import { Suspense } from 'react';
import {Switch, useLocation, Route, Redirect} from 'react-router-dom';
import {useKeycloak} from '@react-keycloak/web';
import PageLoading from '../components/Common/PageLoading';
import DashboardRoutes from './DashboardRoutes';
import { map } from './RouteMap';

const index = () => {
  const location = useLocation();

  const { keycloak, initialized } = useKeycloak();
  const isLoggedIn = keycloak.authenticated;
  if (initialized && !isLoggedIn && keycloak?.login && !['/', map.routes.map].includes(location.pathname)) {
    keycloak?.login?.();
  }

  return (
    <Switch location={location}>
      <Suspense fallback={<PageLoading />}>
        <Route path="/dashboard" component={DashboardRoutes} />
        <Route exact path="/">
          {isLoggedIn ? <Redirect to={map.routes.dashboard} /> : <Redirect to={map.routes.map} />}
        </Route>
      </Suspense>
    </Switch>
  );
};

export default index;
